import { styled, Flex, Spinner } from '@withjoy/joykit';
import { PaletteColorTokens } from '@withjoy/joykit/theme';
import { InlineMessageStatus } from './MessageStatus';

const BACKGROUND_COLOR_BY_MESSAGE_STATUS: Record<InlineMessageStatus, keyof PaletteColorTokens> = {
  warning: 'warning1',
  loading: 'mono1',
};
const BORDER_COLOR_BY_MESSAGE_STATUS: Record<InlineMessageStatus, keyof PaletteColorTokens> = {
  warning: 'warning3',
  loading: 'mono3',
};
export const Wrapper = styled(Flex)<{ messageStatus: InlineMessageStatus; isInline: boolean }>`
  max-width: 448px;
  width: 100%;
  background: ${({ messageStatus, theme }) => theme.colors[BACKGROUND_COLOR_BY_MESSAGE_STATUS[messageStatus]]};
  border: 1px solid ${({ messageStatus, theme }) => theme.colors[BORDER_COLOR_BY_MESSAGE_STATUS[messageStatus]]};
  border-radius: ${({ theme }) => theme.radii[3]};
  padding: ${({ theme, isInline }) => (isInline ? theme.space[6] : theme.space[3])};
  align-items: center;

  @media (max-width: 353px) {
    flex-direction: column;
  }
`;

export const StyledSpinner = styled(Spinner)`
  & div {
    width: 24px;
    height: 24px;
    border-color: ${({ theme }) => theme.colors.mono8};
    border-width: 1px;
    border-top-color: transparent;
    margin: ${({ theme }) => theme.space[1]};
  }
`;
